import axios from 'axios';
import { getIdToken, triggerAuthFailure } from '../auth/cognito';
import { getClientApiBaseUrl } from './endpoints';
/**
 * Create a configured Axios instance for the Tax Assist Manager API
 */
export function createApiClient(config) {
    const instance = axios.create({
        baseURL: getClientApiBaseUrl(),
        timeout: 30000,
        headers: {
            'Content-Type': 'application/json',
        },
        ...config,
    });
    // Request interceptor to add authentication
    instance.interceptors.request.use(async (config) => {
        try {
            const token = await getIdToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        catch (error) {
            console.warn('Failed to add authentication token:', error);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    // Response interceptor for error handling
    instance.interceptors.response.use((response) => {
        return response;
    }, async (error) => {
        if (error.response?.status === 401) {
            // Token expired or authentication failed
            console.warn('Authentication failed - token may be expired');
            // Trigger global auth failure handler (will redirect to login)
            triggerAuthFailure();
        }
        return Promise.reject(error);
    });
    return instance;
}
/**
 * Default Axios instance for Orval-generated client
 */
const defaultClient = createApiClient();
/**
 * Mutator function for Orval-generated client
 * This is the function referenced in orval.config.ts
 */
export const customAxiosInstance = async (config) => {
    const response = await defaultClient(config);
    return response.data;
};
/**
 * Export the default instance for use by generated client
 */
export default customAxiosInstance;
